import { ColorPicker } from 'antd';
import styled from 'styled-components';

export default styled(ColorPicker)`
	// Add your styles here
`;
